object Information {
    val info = listOf(
        "This is a reservation of the seating area and the area around it, including the large table." +
                "The rest of the terrace can be used by others.",
        "Clean the area after your stay. For late stays, make sure its cleaned by 12.00 the next day.",
        "After 23:00 it should be quiet on the terrace. That also applies for the stairs and the elevator."
    )
}